// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"7579d2aafd1d4af2f421","303":"0c806d3f12e6202bf888","495":"207e5e36dde0b478fb13"}[chunkId] + ".js";
};